import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'WorkPackage';
const IconTitle = 'Work package';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.25C3 4.00736 4.00736 3 5.25 3H11.25C11.4489 3 11.6397 3.07902 11.7803 3.21967L13.0607 4.5H18.75C19.9926 4.5 21 5.50736 21 6.75V17.25C21 18.4926 19.9926 19.5 18.75 19.5H5.25C4.00736 19.5 3 18.4926 3 17.25V5.25ZM5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25V17.25C4.5 17.6642 4.83579 18 5.25 18H18.75C19.1642 18 19.5 17.6642 19.5 17.25V6H12.75C12.5511 6 12.3603 5.92098 12.2197 5.78033L10.9393 4.5H5.25ZM8.05449 12.2971C7.06604 11.3087 6.91154 9.80208 7.59099 8.65166L9.64548 10.7061L10.7061 9.64548L8.65165 7.59099C9.80208 6.91154 11.3087 7.06604 12.2971 8.05449C13.1874 8.94475 13.4012 10.2553 12.9384 11.3474L16.2746 14.6836C16.7139 15.123 16.7139 15.8353 16.2746 16.2746C15.8353 16.714 15.123 16.714 14.6836 16.2746L11.3474 12.9384C10.2553 13.4012 8.94475 13.1874 8.05449 12.2971Z" fill="currentColor"/>
  </svg>
`;

const WorkPackageIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 5.25C3 4.00736 4.00736 3 5.25 3H11.25C11.4489 3 11.6397 3.07902 11.7803 3.21967L13.0607 4.5H18.75C19.9926 4.5 21 5.50736 21 6.75V17.25C21 18.4926 19.9926 19.5 18.75 19.5H5.25C4.00736 19.5 3 18.4926 3 17.25V5.25ZM5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25V17.25C4.5 17.6642 4.83579 18 5.25 18H18.75C19.1642 18 19.5 17.6642 19.5 17.25V6H12.75C12.5511 6 12.3603 5.92098 12.2197 5.78033L10.9393 4.5H5.25ZM8.05449 12.2971C7.06604 11.3087 6.91154 9.80208 7.59099 8.65166L9.64548 10.7061L10.7061 9.64548L8.65165 7.59099C9.80208 6.91154 11.3087 7.06604 12.2971 8.05449C13.1874 8.94475 13.4012 10.2553 12.9384 11.3474L16.2746 14.6836C16.7139 15.123 16.7139 15.8353 16.2746 16.2746C15.8353 16.714 15.123 16.714 14.6836 16.2746L11.3474 12.9384C10.2553 13.4012 8.94475 13.1874 8.05449 12.2971Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconTitle,

  IconComponent: WorkPackageIcon,
  IconSvg: IconSvg
} as IconType;
